import { get } from '@/helpers/http'
import { Contact } from '@/types/api/Contact'

export async function fetchContact(groups: string | string[]) {
  return get('projects/contact', { groups: groups }, { opossum: true }) as Promise<Contact>
}
